<template>
  <div>
    <!-- Simple loyalty program - show h2 instead of tabs -->
    <h2
      v-if="showSimpleTitle"
      class="cf-title cf-title--2"
    >
      {{ content.Loyalty.metadata.rewards }}
    </h2>

    <!-- Tabs for multi-tiered or programs with challenges -->
    <div
      v-else
      class="cf-tabs"
    >
      <!-- Challenges tab - always first if shown -->
      <button
        v-if="hasChallenges"
        type="button"
        :class="['cf-tab', { 'cf-tab--active': selectedTab === 'CHALLENGES' }]"
        @click="handleTabButtonClick('CHALLENGES')"
      >
        {{ content.Challenges.metadata.tabTitle }}
      </button>

      <!-- Rewards/Loyalty Allocations tab -->
      <button
        type="button"
        :class="['cf-tab', { 'cf-tab--active': selectedTab === 'REWARDS' }]"
        @click="handleTabButtonClick('REWARDS')"
      >
        {{ content.Loyalty.metadata.rewards }}
      </button>

      <!-- Rewards Store tab - only for multi-tiered programs -->
      <button
        v-if="isMultiTieredLoyaltyProgram"
        type="button"
        :class="['cf-tab', { 'cf-tab--active': selectedTab === 'REWARDS_STORE' }]"
        @click="handleTabButtonClick('REWARDS_STORE')"
      >
        {{ content.Loyalty.metadata.rewardStore }}
      </button>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'LoyaltyAllocationsAndConversionThresholdsTabs',

    props: {
      selectedTab: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['loyalty']),

      hasChallenges() {
        return this.loyalty.challengeLedgers && this.loyalty.challengeLedgers.length > 0;
      },

      isMultiTieredLoyaltyProgram() {
        return this.loyalty.isMultiTiered;
      },

      showSimpleTitle() {
        return !this.hasChallenges && !this.isMultiTieredLoyaltyProgram;
      }
    },

    methods: {
      handleTabButtonClick(tab) {
        this.$emit('set-selected-tab', tab);
      }
    }
  };
</script>
